module.exports = __webpack_public_path__ + "static/media/release_06@3x.35b10a2b.png";